import React, { useState } from "react";
import axios from "axios";
import Modal from "react-modal";
import CloseIcon from "@mui/icons-material/Close";
import { useSnackbar } from "notistack";
import { API_BASE_URL } from "../../config";
import {
  REMARK_BODY_MAX_LENGTH,
  REMARK_SUBJECT_MAX_LENGTH,
  sanitizeRemarkBody,
  sanitizeRemarkSubject,
} from "../../utils/remarkSanitizer";
import "../../stylesheets/passwordReset.css";

Modal.setAppElement("#root");

function Mail({ state, setOpen }) {
  const { enqueueSnackbar } = useSnackbar();
  const [mailingObject, setMailingObject] = useState("");
  const [mailingBody, setMailingBody] = useState("");
  const [isSending, setIsSending] = useState(false);

  const subject = mailingObject.trim();
  const body = mailingBody.trim();
  const canSend = subject.length > 0 && body.length > 0 && !isSending;

  const handleClose = () => {
    if (!isSending) setOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!canSend) return;
    setIsSending(true);

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const response = await axios.post(
        `${API_BASE_URL}/mail`,
        {
          mail_client: user?.email,
          subject: sanitizeRemarkSubject(subject),
          body: sanitizeRemarkBody(body),
        },
        { headers: { "Content-Type": "application/json", Authorization: user?.jwt } }
      );
      if (response.status === 200 && response.data != null) {
        enqueueSnackbar("Message envoyé !", { variant: "success" });
        setMailingObject("");
        setMailingBody("");
        setOpen(false);
      } else {
        enqueueSnackbar("Une erreur est survenue lors de l'envoi", { variant: "error" });
      }
    } catch (error) {
      if (error.response?.status === 401 && error.response.data?.error === "Other_user_connected") {
        localStorage.removeItem("user");
        localStorage.setItem("other_user_connected", "other_user_connected");
        window.location.href = "/login";
        return;
      }
      enqueueSnackbar("Une erreur est survenue lors de l'envoi", { variant: "error" });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Modal
      isOpen={!!state}
      onRequestClose={handleClose}
      className="password-reset-card password-reset-modal"
      overlayClassName="password-reset-overlay"
      aria={{ labelledby: "remarks-title" }}
    >
      <button type="button" className="password-reset-close" aria-label="Fermer" onClick={handleClose}>
        <CloseIcon fontSize="small" />
      </button>

      <h2 id="remarks-title">Vos remarques</h2>

      <form className="password-reset-form" onSubmit={handleSubmit} aria-busy={isSending}>

        <div className="password-reset-field">
          <label htmlFor="remarks-subject">Objet</label>
          <div className="password-reset-input-wrap">
            <input
              id="remarks-subject"
              className="password-reset-input--plain"
              name="subject"
              type="text"
              placeholder="Objet de votre message"
              value={mailingObject}
              maxLength={REMARK_SUBJECT_MAX_LENGTH}
              onChange={(e) => setMailingObject(sanitizeRemarkSubject(e.target.value))}
              disabled={isSending}
              required
            />
          </div>
        </div>

        <div className="password-reset-field">
          <label htmlFor="remarks-body">Message</label>
          <div className="password-reset-input-wrap">
            <textarea
              id="remarks-body"
              name="body"
              rows={6}
              placeholder="Faites-nous part de vos remarques"
              value={mailingBody}
              maxLength={REMARK_BODY_MAX_LENGTH}
              onChange={(e) => setMailingBody(sanitizeRemarkBody(e.target.value))}
              disabled={isSending}
              required
            />
          </div>
          <p className="password-reset-counter" aria-live="polite">
            {mailingBody.length} / {REMARK_BODY_MAX_LENGTH}
          </p>
        </div>

        <button type="submit" className="password-reset-button" disabled={!canSend}>
          {isSending ? "Envoi en cours…" : "Envoyer"}
        </button>
      </form>
    </Modal>
  );
}

export default Mail;
